// Version : 1.0.0
// Author : AGALYA

import { takeLatest, put, all, call } from 'redux-saga/effects';
import AddressExtraProofActionType from './address-extra-proof.types';
import {
	updateAddressExtraProofSuccess,
	updateAddressExtraProofFailure,
	updateAddressExtraProofResponseChanged,
} from './address-extra-proof.action';
import { encryptData } from '../../../_common/enode-decode';
import AlertManager from '../../../../utils/alertManager';
import { addressExtraProofUpdate } from './address-extra-proof.service';

/** ***************** UPDATE ADDRESS EXTRA PROOF START *********************** */
export function* updateAddressExtraProof({ payload }: any) {
	try {
		const key = 'updateAddressExtraProofID';
		const { companyID, databaseName, memberID, addressExtraProofImg, userID } = payload;

		const jsonData = {
			CompanyID: companyID,
			DatabaseName: databaseName,
			MemberID: memberID,
			AddressExtraProofImg: addressExtraProofImg,
			OfficerID: userID,
			Secratekey: key,
		};

		const addressExtraProofData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(addressExtraProofUpdate, addressExtraProofData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(updateAddressExtraProofFailure(responseData.data));
		} else {
			yield put(updateAddressExtraProofSuccess(responseData.data));
		}
	} catch (error) {
		yield put(updateAddressExtraProofFailure(error));
	}
}

export function* updateAddressExtraProofResponseClear() {
	yield put(updateAddressExtraProofResponseChanged());
}

export function* onAddressExtraProofUpdateStart() {
	yield takeLatest(
		AddressExtraProofActionType.UPDATE_ADDRESS_EXTRA_PROOF_START,
		updateAddressExtraProof,
	);
}

export function* onAddressExtraProofUpdateResponseRest() {
	yield takeLatest(
		AddressExtraProofActionType.UPDATE_ADDRESS_EXTRA_PROOF_RESPONSE_REST_START,
		updateAddressExtraProofResponseClear,
	);
}
/** ***************** UPDATE ADDRESS EXTRA PROOF END *********************** */

export function* addressExtraProofSaga() {
	yield all([call(onAddressExtraProofUpdateStart), call(onAddressExtraProofUpdateResponseRest)]);
}
